import React from 'react';

const HighlightText = ({ children, colorClass = "text-primary", underlineClass = "text-highlight-yellow" }) => (
  <span className={`relative inline-block ${colorClass} z-10 whitespace-nowrap`}>
    {children}
    {/* Creative hand-drawn underline SVG */}
    <svg
      className={`absolute left-[-2%] w-[104%] h-[0.45em] bottom-[0.1em] ${underlineClass} -z-10`}
      viewBox="0 0 100 20"
      preserveAspectRatio="none"
    >
      <path
        d="M2 14 C 25 6, 75 6, 98 13"
        stroke="currentColor"
        strokeWidth="6"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  </span>
);

export default HighlightText;